"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDmsInactivityLogout = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _LocalStorage = require("../constants/LocalStorage");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _userInteractionToken = require("../functions/userInteractionToken");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useDmsInactivityLogout = () => {
  var _ref;
  const checkInterval = (_ref = localStorage.getItem(_LocalStorage.LocalStorageVariables.InactivityTimer) * 1000) !== null && _ref !== void 0 ? _ref : -1;
  const navigate = (0, _reactRouterDom.useNavigate)();
  (0, _react.useEffect)(() => {
    if (checkInterval === -1) {
      return;
    }
    let timeoutId;
    let countdownIntervalId;
    const countdownDuration = 10;
    const logoutUser = () => {
      localStorage.clear();
      sessionStorage.clear();
      navigate(0);
    };
    const showCountdownSwal = () => {
      let timeLeft = countdownDuration;
      _sweetalert.default.fire({
        title: _reactIntlUniversal.default.get('InactivityWarning').d('Inactivity Warning'),
        html: _reactIntlUniversal.default.get('CountdownForLoggedOutWarning').d("You will be logged out in <b>".concat(timeLeft, "</b> seconds due to inactivity. Move the mouse to stay logged in.")),
        timer: countdownDuration * 1000,
        timerProgressBar: true,
        didOpen: () => {
          _sweetalert.default.showLoading();
          const timeElement = _sweetalert.default.getHtmlContainer().querySelector('b');
          timeElement.textContent = timeLeft;
          countdownIntervalId = setInterval(() => {
            timeLeft -= 1;
            timeElement.textContent = timeLeft;
          }, 1000);
        },
        willClose: () => {
          clearInterval(countdownIntervalId);
        },
        customClass: {
          container: 'inactivity-modal'
        }
      }).then(result => {
        if (result.dismiss === _sweetalert.default.DismissReason.timer) {
          logoutUser();
        }
      });
    };
    const resetTimer = () => {
      //user interacts so increate tokenUses to refresh token
      (0, _userInteractionToken.userInteractionToken)();
      clearTimeout(timeoutId);
      clearInterval(countdownIntervalId);
      const inactivityModal = document.querySelector('.swal2-container.inactivity-modal');
      if (inactivityModal) {
        _sweetalert.default.close();
      }
      timeoutId = setTimeout(showCountdownSwal, checkInterval);
    };
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    events.forEach(event => {
      window.addEventListener(event, resetTimer);
    });
    resetTimer();
    return () => {
      clearTimeout(timeoutId);
      clearInterval(countdownIntervalId);
      _sweetalert.default.close();
      events.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [checkInterval, navigate]);
};
exports.useDmsInactivityLogout = useDmsInactivityLogout;